/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function HomeIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "home", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M6.5 9V18.5H18.5V9M4.5 10L12.5 5L20.5 10", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M14.5 18.5V11.5H10.5V18.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(HomeIcon);
export default ForwardRef;
//# sourceMappingURL=homeIcon.js.map